export default "__VITE_ASSET__584b312d__"